var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tcuisibaea",
    d: "M0 0.3L33.677 0.3 33.677 34.2 0 34.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1268 -14) translate(1268 14) translate(0 .3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2xo5sl7qnb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tcuisibaea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M0 17.137c0 4.035 3.272 7.307 7.307 7.307h18.647c4.266 0 7.724-3.458 7.724-7.724h-.021C33.432 7.615 25.997.3 16.839.3 7.68.3.246 7.615.02 16.72h-.02v.417z",
    mask: "url(#2xo5sl7qnb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD63E",
    d: "M29.782 16.58c0 7.15-5.795 12.944-12.943 12.944S3.895 23.73 3.895 16.581H20.82c.799 0 1.855-3.91 2.43-3.91.776 0 1.486 3.91 2.165 3.91h4.367z",
    transform: "translate(-1268 -14) translate(1268 14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M12.25 24.744c.796 1.74 2.55 2.952 4.589 2.952 2.04 0 3.792-1.212 4.59-2.952h-9.18z",
    transform: "translate(-1268 -14) translate(1268 14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CAF7",
    d: "M0 17.439C0 8.139 7.54.6 16.84.6 26.138.6 33.678 8.14 33.678 17.44h-7.726c-1.085 0-1.955-4.767-2.61-4.767-1.135 0-2.14 4.767-3.017 4.767H0z",
    transform: "translate(-1268 -14) translate(1268 14)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/UserLogo.3e4da4ea0a3a92e562809b63ec551fa8.svg";
export { ForwardRef as ReactComponent };